<template>
	<div class="index-con">
		<!--北宸可信数据服务中心 -->
		<div class="layoutContent believable">
			<div class="container believable-con">
				<p class="title1">北宸可信数据服务中心</p>
				<span>
					依托国家级区块链网络上海枢纽基础能力建设的数字化服务平台，旨在为各类电子数据提供可信、安全、可靠、高效的数据存证与共享服务。基于区块链不可篡改及可追溯等特性，确保存证数据的真实性和完整性，支持多方参与的数据共享全流程链上溯源，从而广泛应用于航贸、司法、气象等多个领域。
				</span>
				<div class="btnArr flex">
					<el-button round @click="goPath('feature')">产品介绍<i
							class="el-icon-arrow-right el-icon--right"></i></el-button>
					<el-button round @click="goPath('documentCenter')">申请流程<i
							class="el-icon-arrow-right el-icon--right"></i></el-button>
				</div>
			</div>
		</div>
		<!-- 核验中心 -->
		<div class="layoutContent check">
			<div class="container check-con">
				<h1>核验中心</h1>
				<!-- 开始核验 -->
				<el-carousel indicator-position="outside" :interval="5000">
					<el-carousel-item>
						<div class="flex">
							<div class="masterImg" style="margin-right: 20px;">
								<img src="@/assets/img/home/ks1.png" @click="goCheck" />
							</div>
							<div class="masterImg masterImg1">
								<img src="@/assets/img/home/ks2.png" @click="goPath('check')" />
							</div>
						</div>
					</el-carousel-item>
					<el-carousel-item>
						<div class="flex">
							<div class="masterImg masterImg2">
								<img src="@/assets/img/home/ks3.png" @click="goPath('check2')" />
							</div>
						</div>
					</el-carousel-item>
				</el-carousel>
			</div>
		</div>
		<!-- 核心功能 -->
		<div class="container solution">
			<h2 class="text-center">核心功能</h2>
			<el-row type="flex" class="row-bg" justify="space-around" style="margin-top: 35px">
				<el-col :span="11" class="sports solution-box">
					<el-card class="box-card" shadow="none" :body-style="{ padding: '0px' }">
						<dl class="dl1">
							<!-- <dt><img src="@/assets/img/home/icon1.png" width="70" /></dt>
							<dd>数据存证服务</dd>
							<dd>电子签约</dd> -->
						</dl>
					</el-card>
				</el-col>
				<el-col :span="11" class="sports solution-box">
					<el-card class="box-card" shadow="none" :body-style="{ padding: '0px' }">
						<dl class="dl2">
							<!-- <dt><img src="@/assets/img/home/icon2.png" width="70" /></dt>
							<dd>存证验证服务</dd>
							<dd>存证验证和授权</dd> -->
						</dl>
					</el-card>
				</el-col>
				<el-col :span="11" class="sports solution-box">
					<el-card class="box-card" shadow="none" :body-style="{ padding: '0px' }">
						<dl class="dl3">
							<!-- <dt><img src="@/assets/img/home/icon3.png" width="70" /></dt>
							<dd>防伪溯源</dd>
							<dd>航运贸易</dd> -->
						</dl>
					</el-card>
				</el-col>
				<el-col :span="11" class="sports solution-box">
					<el-card class="box-card" shadow="none" :body-style="{ padding: '0px' }">
						<dl class="dl4">
							<!-- <dt><img src="@/assets/img/home/icon3.png" width="70" /></dt>
							<dd>防伪溯源</dd>
							<dd>航运贸易</dd> -->
						</dl>
					</el-card>
				</el-col>
			</el-row>
		</div>
		<!-- 应用场景 -->
		<div class="layoutContent product">
			<div class="container product-con">
				<h1 class="tac">应用场景</h1>
				<el-row :gutter="20">
					<!-- <el-col :span="8" v-for="(item, index) in productList " class="product-box" :key="index">
						<el-card :body-style="{ padding: '0px' }" shadow="hover">
							<div class="text-center card card-none" :style="`background: url(${item.bg}) no-repeat`">
								<img :src="item.img">
								<div class="product_div">
									<h3>{{ item.tit }}</h3>
									<p style="text-align: left">{{ item.con }}</p>
								</div>
							</div>
						</el-card>
					</el-col> -->
					<el-col :span="8" v-for="(item, index) in productList" class="product-box" :key="index">
						<el-card :body-style="{ padding: '10px' }" shadow="hover">
							<img :src="require(`@/assets/img/home/bg${item}.png`)" width="100%" />
						</el-card>
					</el-col>
				</el-row>
			</div>
		</div>
		<!-- 新增合作伙伴  -->
		<!-- <div class="layoutContent partners">
			<div class="container" style="padding: 0 20px;">
				<h2>合作伙伴</h2>
				<ul>
					<li v-for="item in 18" :key="item">
						<img :src="require(`@/assets/img/home/c${item}.png`)" width="100%" />
					</li>
				</ul>
			</div>
		</div> -->
		<!-- 底部关于我们 -->
		<div class="footer">
			<h1>关于我们</h1>
			<div class="container container_ footer-con">
				<img src="@/assets/img/home/foot-bg.png" width="500" />
				<div class="con">
					<p class="p1">长三角数链（上海）网络基础设施有限公司</p>
					<p>
						定位为区块链网络上海枢纽节点基础设施的建设和运营方，负责基础环境、硬件设备、平台软件
						和运营服务体系建设，以及对外公共服务能力提供。公司运营的北宸可信数据服务中心是基于区块
						链网络、分布式数字身份、数据加密技术打造的多层次多主体的架构、多市场主体参与的可信数据
						存证业务生态环境。
					</p>
				</div>
				<div class="bottom-con">
					<div>
						<img src="@/assets/img/home/ph.png" width="28" />
						<span>联系电话：021-64181296</span>
					</div>
					<div>
						<img src="@/assets/img/home/em.png" width="30" />
						<span>邮箱：chainconnect-operation@shdatagroup.com</span>
					</div>
					<div>
						<img src="@/assets/img/home/time.png" width="30" />
						<span>服务时间：工作日9:00至17:00</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'home',
	data() {
		return {
			option: '',
			productList: [5, 6, 7],
			// productList: [
			// 	{
			// 		bg: require('@/assets/img/home/bg4.png'),
			// 		img: require('@/assets/img/home/icon4.png'),
			// 		tit: '航贸场景',
			// 		con: '在航贸领域，存证中心支持电子提单、电子信用证、无纸化放货等数字化流程，加速数据交换和共享，提高业务协同效率。',
			// 		btn: '查看详情',
			// 		href: 'payment',
			// 	},
			// 	{
			// 		bg: require('@/assets/img/home/bg5.png'),
			// 		img: require('@/assets/img/home/icon5.png'),
			// 		tit: '司法仲裁',
			// 		con: '存证中心的高效存证能力和便捷的查询功能，使得证据的使用变得更加高效和便捷，显著提升案件处理速度。',
			// 		btn: '查看详情',
			// 		href: 'dataSystem'
			// 	},
			// 	{
			// 		bg: require('@/assets/img/home/bg6.png'),
			// 		img: require('@/assets/img/home/icon6.png'),
			// 		tit: '其他场景',
			// 		con: '版权保护、电子签约、证件证书、防伪溯源等多个领域',
			// 		btn: '查看详情',
			// 		href: 'dataSDK'
			// 	}
			// ]
		}
	},
	methods: {
		// 跳转
		goPath(path) {
			this.$router.push(`/${path}`)
		},
		// 外链校验
		goCheck() {
			window.location.href = 'https://sheca.yrd-tdh.com:8000/sign-depository-platform'
		},
		// 打开弹窗
		OnOfflineStatus() {
			this.option = this.$message({
				message: `<p style='line-height: 1.4;padding: 0 10px 0 4px'>网站停服维护通知：为了提供更优质的服务和更好的用户体验，我们将于2025-03-28至2025-03-29对网站进行系统升级和维护。在此期间，网站将暂停访问，给您带来不便，敬请谅解。</p>`,
				center: true,
				duration: 0,
				showClose: true,
				offset: 100,
				customClass: 'customClass',
				dangerouslyUseHTMLString: true
			});
		},
		OnOnlineStatus() {
			this.option ? this.option.close() : '';
		},
	},
	// destroyed() {
	// 	this.OnOnlineStatus()
	// },
	// mounted() {
	// 	this.OnOfflineStatus()
	// }
}


</script>

<style lang="less">
@import "../../../style/base.less";
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.index-con {

	// 可信
	.believable {
		height: 580px;
		background: url("../../../assets/img/home/bg.jpg") no-repeat 0 center;
		background-size: 100% 100%;
	}

	.product {
		padding: 90px 0 100px;
		background: #2469e8;
	}

	.container {
		width: 1140px;
		padding: 0;
		margin: 0 auto;
		color: #fff;
	}

	.container_ {
		width: 800px;
	}

	.believable-con {
		padding: 120px 0 20px;

		.title1 {
			font-size: 52px;
			font-weight: 420;
		}

		&>span {
			display: block;
			width: 500px;
			line-height: 1.8;
			margin: 30px 0 40px;
		}
	}

	.check {
		padding: 20px 0 50px;
		background-color: #3375ef;

	}

	.check-con h1 {
		text-align: center;
		padding: 30px 0 30px;
		letter-spacing: 6px;
	}

	/deep/ .el-carousel__indicators {
		padding: 40px 0 0;

	}

	/deep/.el-carousel__indicator--horizontal {
		padding: 12px;
	}

	/deep/ .el-carousel__button {
		width: 30px;
		height: 30px;
		border-radius: 50%;
		background: none;
		border: 5px solid #093adb;
	}

	/deep/ .el-carousel__indicators .is-active {
		.el-carousel__button {
			border: none;
			background: #4bceed;
		}
	}

	.masterImg {
		width: 500px;
		height: 320px;
		background: url("../../../assets/img/home/m-bg-left.png") no-repeat 0 center;
		background-size: 100% 100%;
		margin: 0 auto;
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		box-shadow: 0 0 20px 5px rgba(0, 0, 0, 0.1);

		&>img {
			width: 210px;
			margin: 0 0 60px 40px;
			cursor: pointer;
			transform: scale(1);
			transition: transform 0.3s ease;
		}
	}

	.masterImg1 {
		background: url("../../../assets/img/home/m-bg-right.png") no-repeat 0 center;
		background-size: 100% 100%;
	}

	.masterImg2 {
		background: url("../../../assets/img/home/m-tre.png") no-repeat 0 center;
		background-size: 100% 100%;
	}

	.masterImg img:hover {
		transform: scale(1.03);
	}

	// 底部关于我们
	.footer {
		padding: 45px 0 70px;
		background-color: #ffffff;
		width: 100%;
		box-sizing: border-box;

		h1 {
			letter-spacing: 8px;
			margin-bottom: 20px;
			text-align: center;
		}

		.footer-con {
			position: relative;
			height: 320px;
			background-color: #fff;
			border-radius: 15px;
			border-right: 12px solid #2881f4;
			box-shadow: 0 0 20px 5px rgba(0, 0, 0, 0.1);

			&>img {
				position: absolute;
				top: 0;
				right: 0;
			}

			.con {
				position: absolute;
				top: 0;
				left: 0;
				padding: 40px 30px;

				&>p {
					font-size: 14px;
					color: #333;
					font-weight: 500;
					line-height: 1.3;
				}

				.p1 {
					font-size: 18px;
					margin-bottom: 26px;
				}
			}

			.bottom-con {
				position: absolute;
				left: 30px;
				bottom: 15px;
				color: #000;

				&>img {
					margin-right: 8px;
				}
			}
		}

		&>img {
			margin-bottom: 70px;
			box-shadow: 0 0 20px 5px rgba(0, 0, 0, 0.1);
		}
	}

	.btnArr {

		//   width: 500px;
		.el-button {
			width: 120px;
			background-color: #4bceed;
			color: #fff;
			border-color: #4bceed;
		}

		.el-button.is-round {
			border-radius: 24px;
		}
	}

	.el-menu--horizontal {
		height: 80px;
		line-height: 80px;
		background-color: #002e94;
	}

	.el-menu--horizontal {
		border-bottom: 0 !important;
	}

	.el-menu--horizontal>.el-menu-item {
		height: 80px;
		line-height: 80px;
		font-weight: 500;
		color: #fff;
		letter-spacing: 2px;
	}

	.sports {
		position: relative;
		bottom: 0;
		transition: all 0.3s ease-in-out;
	}

	.sports:hover {
		bottom: 6px;
		box-shadow: 0 6px 18px 0 rgba(232, 237, 250, 0.5);
		cursor: pointer;
	}

	.main-content {
		min-height: 100%;
		box-sizing: border-box;
	}

	.index-logo {
		line-height: 80px;
	}

	.download {
		margin-right: 20px;

		a {
			display: inline-block;
			min-width: 180px;
			border: 1px solid #409eff;
			padding: 10px 0;
			color: #414d5a;
			background: #ffffff;
			text-align: center;
		}

		a:hover {
			color: #409eff;
			text-decoration: none;
		}
	}

	.blue {
		color: #409eff;
	}

	.gray {
		color: #7b8799;
	}

	.introduce {
		margin-top: 30px;
		color: #7b8799;
	}

	.circle-dot:before {
		content: "";
		display: inline-block;
		width: 10px;
		height: 10px;
		border-radius: 50%;
		vertical-align: middle;
		background: #20a0ff;
		margin-right: 10px;
	}

	.banner {
		max-width: 1370px;
		margin: 0 auto;
	}

	.el-carousel {
		margin-top: 40px;
	}

	.el-carousel__indicators--outside {
		margin-top: 20px;

		.el-carousel__button {
			height: 4px;
		}
	}

	// .el-carousel__item h3 {
	// 	color: #475669;
	// 	font-size: 14px;
	// 	opacity: 0.75;
	// 	line-height: 200px;
	// 	margin: 0;
	// }

	// .el-carousel__item img {
	// 	width: 100%;
	// 	background: #ffffff;
	// }

	// .el-carousel__arrow {
	// 	height: 50px;
	// 	width: 50px;
	// }


	.row-bg {
		display: flex;
		flex-flow: row wrap;
		align-content: flex-start;
	}

	.solution {
		padding: 50px 20px 80px;

		.el-card {
			background: none;
			border: none;
			margin-bottom: 35px;
		}

		dl {
			height: 260px;
		}

		.dl1 {
			background: url("../../../assets/img/home/d1.png") no-repeat 0 center;
			background-size: 100% 100%;
		}

		.dl2 {
			background: url("../../../assets/img/home/d2.png") no-repeat 0 center;
			background-size: 100% 100%;
		}

		.dl3 {
			background: url("../../../assets/img/home/d3.png") no-repeat 0 center;
			background-size: 100% 100%;
		}

		.dl4 {
			background: url("../../../assets/img/home/d4.png") no-repeat 0 center;
			background-size: 100% 100%;
		}

		dt {
			color: #009ef6;
			font-size: 22px;
			margin-bottom: 28px;
		}

		dd {
			color: #000;
			font-size: 18px;
			line-height: 30px;
		}

		>h2 {
			color: #000000;
		}

	}

	.title {
		font-size: 40px;
	}

	.product {
		padding-top: 40px;
	}

	.product-box {
		margin-top: 28px;
		position: relative;
		bottom: 0;
		transition: all .3s ease-in-out;

		.el-card {
			background: none;
			border: none;
		}
	}

	.card {
		width: 100%;
		position: relative;

		.product_div {
			padding: 10px 0 30px;
			background: rgba(32, 116, 221, .5);
		}

		h3 {
			font-size: 18px;
			color: #fff;
		}

		img {
			height: 100px;
			width: 100px;
			margin: 120px 0 30px 0;
		}

		p {
			height: 50px;
			margin-top: 15px;
			font-size: 14px;
			color: #fff;
			padding: 0 25px;
			line-height: 20px;
		}

		a {
			height: 52px;
			line-height: 52px;
			font-size: 14px;
			color: #409eff;
			text-align: center;
			border: 0;
			border-top: 1px solid #eaeefb;
			padding: 0;
			position: absolute;
			bottom: 0;
			left: 0;
			cursor: pointer;
			width: 100%;
			background-color: #fff;
			border-radius: 0 0 5px 5px;
			transition: all .3s;
			text-decoration: none;
			display: block;
		}
	}

	.product-box:hover {
		bottom: 6px;
		box-shadow: 0 6px 18px 0 rgba(232, 237, 250, .5)
	}

	.card a:hover {
		color: #fff;
		background: #409eff
	}

	.card .bg-gray:hover {
		background: #ffffff;
		color: #409eff;
	}

	// 合作伙伴
	.partners {
		padding: 20px 0 30px;
		background-color: #f0f0f0;

		h2 {
			color: #000;
			letter-spacing: 8px;
			padding: 20px 0;
			text-align: center;
		}

		ul {
			display: flex;
			flex-flow: row wrap;
			align-content: flex-start;
		}

		li {
			flex: 0 0 22%;
			margin-right: 3%;
			margin-bottom: 3%;
		}

	}

	.bottom-con {
		&>div {
			display: flex;
			align-items: center;
			margin-bottom: 4px;

			img {
				margin-right: 10px;
			}
		}
	}


	@media (max-width: 768px) {
		.solution {
			padding: 30px 0 80px 0;

			h3 {
				text-align: left;
				padding: 0 20px;
				font-size: 20px;
			}
		}

		.product-box {
			width: 80%;
			float: none;
			margin: 0 auto 20px;
		}

		.el-row--flex {
			display: block;
		}

		.solution-box {
			width: 80%;
			float: none;
			margin: 0 auto 20px;

			dl {
				padding: 30px;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/content/home/index.vue